import { ComponentConfig, Slot } from '@measured/puck';

import { Card, CardProps } from '../../../../components/atoms/card/card';
import { StickOnScrollWrapper } from '../../components/stick-on-scroll-wrapper';

type CardBlockProps = {
  background: CardProps['background'];
  content: Slot;
  sticky: boolean;
  stickyTopMargin: number;
};

const CardBlock: ComponentConfig<CardBlockProps> = {
  defaultProps: {
    background: 'default',
    content: [],
    sticky: false,
    stickyTopMargin: 0,
  },

  fields: {
    background: {
      type: 'radio',
      options: [
        { label: 'Transparent', value: 'transparent' },
        { label: 'Default', value: 'default' },
        { label: 'Muted', value: 'muted' },
      ],
    },
    content: {
      type: 'slot',
    },
    sticky: {
      label: 'Sticky position on scroll',
      type: 'radio',
      options: [
        { label: 'On', value: true },
        { label: 'Off', value: false },
      ],
    },
    stickyTopMargin: {
      label: 'Top margin for sticky position (if on)',
      type: 'number',
    },
  },
  label: 'Card',
  render: ({ background, content: Content, sticky, stickyTopMargin }) => {
    return (
      <StickOnScrollWrapper active={sticky} topMargin={stickyTopMargin}>
        <Card background={background} className="print:break-inside-avoid-page ">
          <Content />
        </Card>
      </StickOnScrollWrapper>
    );
  },
  resolveFields: (data, other) => {
    return {
      ...other.fields,
      stickyTopMargin: {
        ...other.fields.stickyTopMargin,
        visible: data.props.sticky,
      },
    };
  },
};

export { CardBlock };
